import { DeviceProtocol } from '@hid/device/device_model'
import { BaseDriver } from './device'
import { CompxPairResult, SpecificItem } from '@libs/types/enum'
import { DeviceChange, DeviceChangeType, ResDeviceState } from '@libs/types/response'
import { CompxCommand, he6UltraData, CompxEepromAddr, he6UltraPower } from './data_conversion/he6_ultra'
import { OutputMode } from '@hid/define/define'
import { fakeSocket } from '@hid/fakesocket/fakesocket'
import { delay, generateMessageID } from '@libs/utils/tools'
import { DriverSocketMsgType } from '@libs/types/message'

export class he6UltraDriver extends BaseDriver {
  updateFirmware(): Promise<boolean> {
    throw new Error('Method not implemented.')
  }
  private reportID = 0x08
  async syncCustomColor() {}
  async syncDecorationLed() {}

  constructor(protocol: DeviceProtocol) {
    super(protocol)

    // 0x0a 是 He6Ultra 主动推送的状态帧（不是命令回包）。以前由 device_model 硬编码过滤，
    // 现在下沉到驱动层，按方案商边界规范说明“这些帧不应被调度器当作回包”。
    this.DeviceHID.registerResponseFilter((data) => data[0] === 0x0a)

    this.receiveNotifications()
    //this.pollingStatus()
  }

  private receiveNotifications() {
    this.DeviceHID.onReciveAny((data) => {
      if (data[0] == CompxCommand.StatusChanged) {
        var value = data[5]
        console.log('StatusChanged', value, data)
        if ((value & 0x01) == 0x01) {
          this.notifyDPI()
        }

        // if ((value & 0x02) == 0x02) {
        //     //ReportRate;
        // }

        // if ((value & 0x40) == 0x40) {
        //     this.notifyBattery();
        // }
      }
    })
  }

  private async notifyDPI() {
    const res = await this.getDeviceData(CompxEepromAddr.CurrentDPI, 1)
    const index = res[5]
    if (index < 0 || index > this.save.Mouse.DpiList.length - 1) {
      return
    }
    this.changeDpi(index)
    const notifyData: DeviceChange = {
      ChangeType: DeviceChangeType.dpi,
      ChangeData: {
        DpiIndex: index,
      },
    } as DeviceChange
    this.notifyData(notifyData)
  }

  // private async notifyBattery() {
  //     const notifyData: DeviceChange = {
  //         ChangeType: DeviceChangeType.power,
  //     } as DeviceChange
  //     this.notifyData(notifyData)
  // }

  private async notifyData(data: any) {
    fakeSocket.onmessage({
      data: JSON.stringify({
        ID: generateMessageID(),
        Type: DriverSocketMsgType.MSDeviceChange,
        Data: data,
        Error: null,
      }),
    } as MessageEvent)
  }

  private isSleep = false
  // private async pollingStatus() {
  //     if (deviceManager.deviceID == VirtualHe6Ultra_24g) {
  //         setInterval(async () => {
  //             const res = await this.sendCommand(CompxCommand.DeviceOnLine)
  //             const isSleep = res[5] == 0x00
  //             // console.log("isSleep:", this.isSleep, res)
  //             if (isSleep != this.isSleep) {
  //                 this.isSleep = isSleep

  //                 const data: DeviceChange = {
  //                     ChangeType: DeviceChangeType.status,
  //                     State: {
  //                         ConnectType: DeviceConnectMode.Wireless24G,
  //                         IsSleep: this.isSleep,
  //                         IsConnect: true
  //                     }
  //                 } as DeviceChange
  //                 fakeSocket.onmessage({
  //                     data: JSON.stringify({
  //                         ID: generateMessageID(),
  //                         Type: 0xf2,
  //                         Data: data,
  //                         Error: null
  //                     })
  //                 } as MessageEvent)
  //             }

  //         }, 1000);
  //     }
  // }

  Magnet() {
    return null
  }
  async setOrReadSpecificItem(item: SpecificItem, isWrite: boolean, value: any) {
    if (item == SpecificItem.PowerLevel) {
      return await this.getPower()
    } else if (item == SpecificItem.PowerIsCharging) {
      return await this.getPowerIsCharging()
    } else if (item == SpecificItem.PollingRate) {
      return await this.reportRate(isWrite, value)
    } else if (item == SpecificItem.SensorMode) {
      return await this.sensorMode(isWrite, value)
    } else if (item == SpecificItem.SensorLod) {
      return await this.sensorLod(isWrite, value)
    } else if (item == SpecificItem.SensorMotionSync) {
      return await this.sensorMotionSync(isWrite, value)
    } else if (item == SpecificItem.MouseDebounce) {
      return await this.mouseDebounce(isWrite, value)
    } else if (item == SpecificItem.SleepTime) {
      return await this.sleepTime(isWrite, value)
    } else if (item == SpecificItem.RippleControl) {
      return await this.rippleControl(isWrite, value)
    } else if (item == SpecificItem.LineCorrection) {
      return await this.lineCorrection(isWrite, value)
    } else if (item == SpecificItem.LongDistance) {
      return await this.longDistance(isWrite, value)
    } else if (item == SpecificItem.HighPerformance) {
      return await this.highPerformance(isWrite, value)
    } else if (item == SpecificItem.HighPerformanceState) {
      return await this.highPerformanceState(isWrite, value)
    }
  }

  private async rippleControl(isWrite: boolean, value: any) {
    if (isWrite) {
      await this.setDeviceEepromValue(CompxEepromAddr.Ripple, value)
    } else {
      const res = await this.getDeviceData(CompxEepromAddr.Ripple, 1)
      return res[5]
    }
  }

  private async lineCorrection(isWrite: boolean, value: any) {
    if (isWrite) {
      await this.setDeviceEepromValue(CompxEepromAddr.Angle, value)
    } else {
      const res = await this.getDeviceData(CompxEepromAddr.Angle, 1)
      return res[5]
    }
  }

  private async longDistance(isWrite: boolean, value: any) {
    if (isWrite) {
      const data = Array(10).fill(0)
      data[0] = value
      await this.sendCommand(CompxCommand.SetLongRangeMode, data)
    } else {
      const res = await this.sendCommand(CompxCommand.GetLongRangeMode)
      return res[5]
    }
  }

  private async highPerformance(isWrite: boolean, value: any) {
    if (isWrite) {
      value = value / 10
      await this.setDeviceEepromValue(CompxEepromAddr.Performance, value)
    } else {
      const res = await this.getDeviceData(CompxEepromAddr.Performance, 1)
      return res[5] * 10
    }
  }

  private async highPerformanceState(isWrite: boolean, value: any) {
    if (isWrite) {
      await this.setDeviceEepromValue(CompxEepromAddr.PerformanceState, value)
    } else {
      const res = await this.getDeviceData(CompxEepromAddr.PerformanceState, 1)
      return res[5]
    }
  }

  private async getPower() {
    const res = await this.sendCommand(CompxCommand.BatteryLevel)
    const level = he6UltraPower.setDisplayLevel(res[5], (res[7] << 8) + res[8], res[6] == 1)
    console.log('getPower', level, res[5], res)
    return res[5]
  }

  private async getPowerIsCharging() {
    const res = await this.sendCommand(CompxCommand.BatteryLevel)
    return res[6]
  }

  private async sensorMode(isWrite: boolean, value: any) {
    if (isWrite) {
      value = value == 256 ? 2 : value
      await this.setDeviceEepromValue(CompxEepromAddr.SensorMode, value)
    } else {
      const res = await this.getDeviceData(CompxEepromAddr.SensorMode, 1)
      let mode = res[5]
      if (mode == 256) {
        mode = 2
      }
      return mode
    }
  }

  // 0x00:1mm 0x01:2mm
  private async sensorLod(isWrite: boolean, value: any) {
    if (isWrite) {
      if (value == 0x00) {
        value = 0x01
      } else if (value == 0x01) {
        value = 0x02
      }
      await this.setDeviceEepromValue(CompxEepromAddr.LOD, value)
    } else {
      const res = await this.getDeviceData(CompxEepromAddr.LOD, 1)
      let option = 0
      if (res[5] == 0x02) {
        option = 1
      }
      return option
    }
  }

  private async sensorMotionSync(isWrite: boolean, value: any) {
    if (isWrite) {
      await this.setDeviceEepromValue(CompxEepromAddr.MotionSync, value)
    } else {
      const res = await this.getDeviceData(CompxEepromAddr.MotionSync, 1)
      return res[5]
    }
  }

  private async mouseDebounce(isWrite: boolean, value: any) {
    if (isWrite) {
      await this.setDeviceEepromValue(CompxEepromAddr.DebounceTime, value)
    } else {
      const res = await this.getDeviceData(CompxEepromAddr.DebounceTime, 1)
      return res[5]
    }
  }

  private async sleepTime(isWrite: boolean, value: any) {
    if (isWrite) {
      value = value / 10
      await this.setDeviceEepromValue(CompxEepromAddr.SleepTime, value)
    } else {
      const res = await this.getDeviceData(CompxEepromAddr.SleepTime, 2)
      return res[5] * 10
    }
  }

  async getVersion() {
    //const res = await this.sendCommand(CompxCommand.GetDongleVersion)
    const res = await this.sendCommand(CompxCommand.ReadVersionID)
    var version = res[5].toString() + '.' + res[6].toString(16).padStart(2, '0')
    return version
  }

  async pair24g() {
    await this.sendCommand(CompxCommand.DongleEnterPair, [0, 0])
    const res = await this.getPairResult()
    return res
  }

  private pairTimerCount = 20
  private pairTimerID: null | NodeJS.Timeout = null
  private async getPairResult(): Promise<number> {
    return new Promise((resolve) => {
      let time = 0
      this.pairTimerID = setInterval(async () => {
        time++
        const res = await this.sendCommand(CompxCommand.GetPairState)
        if ((res[5] == CompxPairResult.Success || res[5] == CompxPairResult.Fail) && this.pairTimerID) {
          resolve(res[5])
          clearInterval(this.pairTimerID)
        }

        if (this.pairTimerID && time >= this.pairTimerCount) {
          resolve(CompxPairResult.Fail)
          clearInterval(this.pairTimerID)
        }
      }, 1000)
    })
  }

  async reportRate(isWrite: boolean, value: any) {
    let reportRate = 1
    if (isWrite) {
      reportRate = value <= 1000 ? 1000 / value : (value / 2000) * 0x10
      await this.setDeviceEepromValue(CompxEepromAddr.ReportRate, reportRate)
    } else {
      const data = await this.getDeviceData(CompxEepromAddr.ReportRate, 2)
      reportRate = 1000 / data[5] > 100 ? 1000 / data[5] : (data[5] / 0x10) * 2000
      return reportRate
    }
  }

  async getDeviceState(): Promise<ResDeviceState> {
    const resData = await this.sendCommand(CompxCommand.DeviceOnLine)
    this.isSleep = resData[5] == 0x00
    const res: ResDeviceState = {
      ConnectType: 0,
      IsSleep: this.isSleep,
      IsConnect: true,
    }
    return res
  }

  async syncLeds() {
    const data = this.save.LightMode

    let LightSwitch = data.Mode == 0 ? false : true
    if (LightSwitch) {
      await this.setDeviceEepromValue(CompxEepromAddr.DPIEffectState, 1)
      await this.setDeviceEepromValue(CompxEepromAddr.DPIEffectMode, data.Mode)
      if (data.Mode == 1) {
        await this.setDeviceEepromValue(CompxEepromAddr.DPIEffectBrightness, he6UltraData.setDpiLightBrightness(data.Light))
      }
      if (data.Mode == 2) {
        await this.setDeviceEepromValue(CompxEepromAddr.DPIEffectSpeed, data.Speed)
      }
    } else {
      await this.setDeviceEepromValue(CompxEepromAddr.DPIEffectState, 0)
    }
  }

  async syncKeys() {
    const keysData = this.save.Keys
    for (let i = 0; i < keysData.length; i++) {
      const key = keysData[i]
      if (key.Output.Mode != OutputMode.Macro && key.Output.Mode != OutputMode.Magnet) {
        const data = he6UltraData.encodeKeyAdapter(key)
        for (let j = 0; j < data.length; j++) {
          const keyData = data[j]
          const addr = keyData.splice(0, 1)
          // console.log("syncKeys", addr, keyData);
          await this.setDeviceEeprom(addr[0], keyData)
        }
      }
    }
    this.clearResetKeys()
  }

  async reset() {
    await this.sendCommand(CompxCommand.ClearSetting)
  }

  async syncConfig() {
    const data = this.save.Mouse
    const setData: number[][] = []
    await this.setDeviceEepromValue(CompxEepromAddr.maxDpiStage, data.DpiList.length)

    for (let index = 0; index < data.DpiList.length; index++) {
      const dColor = data.DpiColors[index]
      const sData = he6UltraData.setDpiColor(index, dColor)
      setData.push(sData)
      const dData = he6UltraData.setDpiValue(index, data.DpiList[index])
      setData.push(dData)
    }

    await this.setDeviceEepromValue(CompxEepromAddr.CurrentDPI, data.DpiIndex)
    await delay(10)

    for (let index = 0; index < setData.length; index++) {
      const sData = setData[index]
      const addr = sData.splice(0, 1)
      await this.setDeviceEeprom(addr[0], sData)
      await delay(10)
    }

    if (this.changeProfileFlag) {
      const items = this.save.Items
      const keysArray = Array.from(items.keys())
      for (let index = 0; index < keysArray.length; index++) {
        const key = keysArray[index]
        await this.setOrReadSpecificItem(key, true, items.get(key))
        await delay(10)
      }
    }
  }

  async syncMacros() {
    for (let i = 0; i < this.save.Keys.length; i++) {
      const key = this.save.Keys[i]
      if (key.Output.Mode == OutputMode.Macro && key.Output.DataIndex >= 0) {
        const keyData = he6UltraData.macroKey(key)
        const macro = this.save.Macros.get(key.Output.DataIndex)
        if (macro) {
          const keyAddr = keyData.splice(0, 1)
          await this.setDeviceEeprom(keyAddr[0], keyData)

          const mData = he6UltraData.macroData(key.Input.KK, macro, key.Output.DataIndex)
          for (let index = 0; index < mData.length; index++) {
            const data = mData[index]
            const addr = data.splice(0, 1)
            await this.setDeviceEeprom(addr[0], data)
          }
        }
      }
    }
  }

  async syncDynamicColor(): Promise<boolean> {
    return true
  }

  async getDeviceOnline() {
    const res = await this.sendCommand(CompxCommand.DeviceOnLine)
    if (res[5] === 1) {
      return true
    }
    return false
  }

  async sendCommand(com: number, value?: number[]) {
    const data = Array(16).fill(0)
    data[0] = com
    if (value && value.length > 0) {
      data[4] = value.length
      for (let i = 0; i < value.length; i++) {
        data[5 + i] = value[i]
      }
    }
    return await this.sendData(data)
  }

  private async sendData(value: number[]) {
    const crc = he6UltraData.getCrc(value)
    value[15] = (crc - this.reportID) & 0xff
    //console.log("sendData", crc, value);
    const result = await this.DeviceHID.send(value)
    return result
  }

  async setDeviceEeprom(address: number, value: number[]) {
    var sendTimes = value.length % 10
    sendTimes = sendTimes > 0 ? Math.floor(value.length / 10) + 1 : Math.floor(value.length / 10)

    for (var i = 0; i < sendTimes; i++) {
      let data = Array(16).fill(0)

      var add = address + i * 10
      var len = (i + 1) * 10 > value.length ? value.length - i * 10 : 10

      data[0] = CompxCommand.WriteFlashData
      data[2] = add >> 8
      data[3] = add & 0xff
      data[4] = len
      data[15] = 0xef
      for (var j = 0; j < 10; j++) {
        if (j < len) {
          data[5 + j] = value[j + i * 10]
        } else {
          data[5 + j] = 0
        }
        // console.log("setDeviceEeprom", 5 + j, data[5 + j]);
      }
      //console.log("setDeviceEeprom", address, add, data);
      await this.sendData(data)
    }
  }
  async setDeviceEepromValue(address: number, value: number) {
    let data = Array(16).fill(0)
    data[0] = CompxCommand.WriteFlashData
    data[2] = address >> 8
    data[3] = address & 0xff
    data[4] = 0x02
    data[5] = value
    data[6] = 0x55 - value
    data[15] = 0xef
    return await this.sendData(data)
  }

  async getDeviceData(address: number, length: number) {
    let data = [CompxCommand.ReadFlashData, 0x00, address >> 8, address & 0xff, length, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0xef]
    return await this.sendData(data)
  }
}
